import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const createChileanBankAccount = async data => {
  return await privateRequest.post(ConfEnv.API_WALLET.URL_CHILEAN_BANK_ACCOUNT, data);
};

export const getChileanBankAccounts = async () => {
  return await privateRequest.get(ConfEnv.API_WALLET.URL_CHILEAN_BANK_ACCOUNTS);
};

export const deleteChileanBankAccount = async id => {
  return await privateRequest.delete(`${ConfEnv.API_WALLET.URL_CHILEAN_BANK_ACCOUNT}/${id}`);
};
